import React from 'react';
import Grid from '@material-ui/core/Grid';
import cx from 'clsx';

import { LETTER_CARDS, MAX_SECRET_CODE_WIDTH } from '../constants';

export const getSecretCode = (
  classes: Record<string, string>,
  secretCode: string
): React.ReactElement[] => {
  const toReturn = [];
  for (let i = 0; i < MAX_SECRET_CODE_WIDTH; i++) {
    const letterCardChar = secretCode.charAt(i);
    const letterBox = (
      <Grid item xs={2} key={'box-' + i} className={classes.letterCardSelectionBox}>
        <div className={classes.codeLetterContainer}>
          {letterCardChar && (
            <img
              key={i}
              className={classes.letterCardSelectionImage}
              src={LETTER_CARDS[letterCardChar]}
              alt={letterCardChar}
            />
          )}
        </div>
      </Grid>
    );
    toReturn.push(letterBox);
  }

  return toReturn;
};

export const getLettercardRow = (
  elements: Array<string>,
  classes: Record<string, string>,
  disabled?: boolean,
  handleElementSelect?: React.MouseEventHandler<HTMLImageElement>
): React.ReactElement[] => {
  return elements.map((element: string) => {
    return (
      <Grid key={element} item xs={2} className={classes.rowItem}>
        <img
          className={cx(classes.letterCardOption, {
            [classes.disabled]: disabled
          })}
          src={LETTER_CARDS[element]}
          alt={element}
          onClick={!disabled ? handleElementSelect : undefined}
        />
      </Grid>
    );
  });
};
